module.exports = __webpack_public_path__ + "img/39712931000158.6c1ab87d.png";